import React from "react";
import { useMutation } from '@apollo/client';
import WebsitesForm from "../../../components/forms/Campaign/WebsitesForm";
import SingleLineField from "../../../components/forms/SingleLineField";
import FormModal from "../../../components/modals/FormModal";
import { useCurrentUser } from "../../../utils/CurrentUserContext";
import { useModal } from "../../../utils/hooks";
import { httpUrlRule } from "../../../utils/validators";
import SettingsCard from "./SettingsCard";
import DropdownField from '../../../components/forms/DropdownField';
import { CREATE_WEBSITE, EnumWebsiteType } from "../../../utils/api/website";
import { Website } from "../../../__generated__/graphql";
import {useNavigate} from 'react-router-dom';

export const typeOptions = [
  { value: EnumWebsiteType.BLOG, label: 'Blog' },
  { value: EnumWebsiteType.ENTERTAINMENT, label: 'Entertainment' },
  { value: EnumWebsiteType.FASHION, label: 'Fashion' },
  { value: EnumWebsiteType.FOOD_AND_LIFESTYLE, label: 'Food and Lifestyle' },
  { value: EnumWebsiteType.HOME_AND_GARDEN, label: 'Home and Garden' },
  { value: EnumWebsiteType.NEWS, label: 'News' },
  { value: EnumWebsiteType.SCIENCE, label: 'Science' },
  { value: EnumWebsiteType.SPORT, label: 'Sport' },
  { value: EnumWebsiteType.TABLOID, label: 'Tabloid' }
]

const AdvancedWebsites = () => {
  const {isAdmin} = useCurrentUser()
  const [modalVisible, showModal, hideModal] = useModal()
  const navigate = useNavigate();

  const [createWebsite] = useMutation(CREATE_WEBSITE, {
    refetchQueries: ['GetAllWebsites']
  })

  const handleOk = async (input: Website) => {
    await createWebsite({ variables: {input}})
  }

  const tableProps = isAdmin
  ? {
    actionButtonText: 'Add website',
    onActionButtonClick: showModal,
    onRowClicked: (record: Website) => {
      navigate(`/settings/websites/${record._id}/details`);
    }
  }
  : {}

  return (
    <SettingsCard
      title="Websites"
      description="A list of all the websites including their name, type, cost per read, minimum spend and visitors."
    >
      <WebsitesForm
        className="mt-8"
        selectable={false}
        {...tableProps}
      />

      <FormModal
        open={modalVisible}
        title="Add Website"
        okText="Add"
        onCancel={hideModal}
        onOk={handleOk}
      >
        <SingleLineField
          top
          label="Website"
          htmlfor="name"
          required
        />
        <SingleLineField
          label="URL"
          htmlfor="url"
          required
          rules={{ validate: { format: httpUrlRule } }}
        />
        <DropdownField
          label="Type"
          options={typeOptions}
          htmlfor="type"
          required
        />
        <SingleLineField
          label="Minimum spend"
          htmlfor="minimumSpend"
          type="number"
          required
        />
      </FormModal>
    </SettingsCard>
  );
};

export default AdvancedWebsites;
